import React, { useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { CheckCircle } from 'lucide-react';

function PasswordChanged() {
    useEffect(() => {
        document.title = 'Password Changed';
        
        // Add theme class based on domain
        const domain = window.location.host.split('.').slice(-2).join('.').toLowerCase();
        if (domain === "rxhacker.com" || domain === "localhost:5464" || 
            window.location.host.toLowerCase() === "tempfilter.23byt.es" || 
            window.location.host.toLowerCase() === "reporting.nulifespanrx.com") {
            document.body.classList.add('rx-user');
        }
    }, []);

    const getLogoUrl = () => {
        const host = window.location.host.toLowerCase();
        const domain = window.location.host.split('.').slice(-2).join('.').toLowerCase();
        
        if (host === "reporting.patientrxdiscount.com") {
            return '/Patient-Rx-Discount.svg';
        } else if (domain === "rxhacker.com" || domain === "localhost:5464" || 
                   host === "tempfilter.23byt.es" || host === "reporting.nulifespanrx.com") {
            return '/Rxhacker_logo_new.png';
        } else if (domain === "glichealth.com") {
            return '/GlicHealth_logo.png';
        } else if (domain === "honestdiscounts.com") {
            return '/hdrx-logo.svg';
        }
        return '/GlicHealth_logo.png';
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-background p-4">
            <Card className="w-full max-w-md shadow-lg border bg-card">
                <CardContent className="p-6 lg:py-8 lg:px-8">
                    {/* Logo */}
                    <div className="flex justify-center mb-4">
                        <img 
                            src={window.location.origin + getLogoUrl()} 
                            alt="logo" 
                            className="w-[190px] object-contain"
                            crossOrigin="anonymous"
                        />
                    </div>

                    {/* Success Icon */}
                    <div className="flex justify-center mb-6">
                        <div className="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center">
                            <CheckCircle className="w-10 h-10 text-green-600" />
                        </div>
                    </div>

                    {/* Message */}
                    <p className="text-center text-slate-700 mb-8">
                        Your new password has been sent to your email address. Please be sure to check your spam folder.
                    </p>

                    {/* Back to Login Button */}
                    <NavLink to="/login" className="block">
                        <Button 
                            className="w-full font-semibold bg-primary hover:bg-primary/90 text-primary-foreground"
                        >
                            Go to Sign In
                        </Button>
                    </NavLink>
                </CardContent>
            </Card>
        </div>
    );
}

export default PasswordChanged;

